/** Nature of a general-sale (מכר כללי) transaction. */
export enum GeneralSaleTransactionType {
  SECOND_HAND_SALE = 'second_hand_sale',
  OPTION_ASSIGNMENT = 'option_assignment'
}
